import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [];
